(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mw-creator-rewards"]) return;
  try {
    
document.querySelectorAll('[data-mw-cr-carousel]').forEach(function(carousel){
  var rail=carousel.querySelector('[data-mw-cr-rail]');
  var prev=carousel.querySelector('[data-mw-cr-prev]');
  var next=carousel.querySelector('[data-mw-cr-next]');
  var index=carousel.querySelector('[data-mw-cr-index]');
  var progress=carousel.querySelector('[data-mw-cr-progress]');
  if(!rail)return;
  var cards=Array.from(rail.querySelectorAll('.mw-cr__card'));
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timer;
  var resumeTimer;

  function current(){
    if(!cards.length)return 0;
    var best=0;
    var bestDistance=Infinity;
    cards.forEach(function(card,i){
      var distance=Math.abs(card.offsetLeft-rail.scrollLeft);
      if(distance<bestDistance){bestDistance=distance;best=i;}
    });
    return best;
  }
  function update(){
    var i=current();
    if(index)index.textContent=String(i+1).padStart(2,'0')+' / '+String(cards.length).padStart(2,'0');
    if(progress)progress.style.width=((i+1)/cards.length*100)+'%';
  }
  function go(i){
    if(!cards.length)return;
    var target=(i+cards.length)%cards.length;
    rail.scrollTo({left:cards[target].offsetLeft,behavior:reduced?'auto':'smooth'});
  }
  function move(direction){go(current()+direction);}
  if(prev)prev.addEventListener('click',function(){stop();move(-1);resume();});
  if(next)next.addEventListener('click',function(){stop();move(1);resume();});
  rail.addEventListener('scroll',function(){window.requestAnimationFrame(update);},{passive:true});
  function stop(){if(timer)window.clearInterval(timer);timer=null;}
  function start(){
    stop();
    if(reduced||rail.scrollWidth<=rail.clientWidth||document.hidden)return;
    timer=window.setInterval(function(){go(current()+1);},5500);
  }
  function resume(){if(resumeTimer)window.clearTimeout(resumeTimer);resumeTimer=window.setTimeout(start,1800);}
  carousel.addEventListener('pointerenter',stop);
  carousel.addEventListener('pointerleave',start);
  carousel.addEventListener('focusin',stop);
  carousel.addEventListener('focusout',start);
  carousel.addEventListener('touchstart',stop,{passive:true});
  carousel.addEventListener('touchend',resume,{passive:true});
  document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start();});
  update();
  start();
});

var mwCrReduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if(!mwCrReduced){
  var reveals=document.querySelectorAll('[data-mw-cr-reveal]');
  if('IntersectionObserver' in window){
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },{threshold:.1,rootMargin:'0px 0px -4% 0px'});
    reveals.forEach(function(el){observer.observe(el);});
  }else{
    reveals.forEach(function(el){el.classList.add('is-visible');});
  }
}

document.querySelectorAll('[data-mw-chapter-choice]').forEach(function(link){
  link.addEventListener('click',function(){
    var select=document.getElementById('mw-cr-chapter');
    var wanted=link.getAttribute('data-mw-chapter-choice');
    if(!select||!wanted)return;
    Array.from(select.options).forEach(function(option){
      if(option.value===wanted)select.value=wanted;
    });
  });
});

var mwCrFine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
if(mwCrFine&&!mwCrReduced){
  function pointerRatio(el,event){
    var r=el.getBoundingClientRect();
    return {x:(event.clientX-r.left)/r.width,y:(event.clientY-r.top)/r.height,r:r};
  }

  document.querySelectorAll('[data-mw-cr-spotlight]').forEach(function(el){
    el.addEventListener('pointerenter',function(){el.classList.add('is-pointer-active');});
    el.addEventListener('pointermove',function(e){
      var p=pointerRatio(el,e);
      el.style.setProperty('--cr-spot-x',(p.x*100).toFixed(1)+'%');
      el.style.setProperty('--cr-spot-y',(p.y*100).toFixed(1)+'%');
    });
    el.addEventListener('pointerleave',function(){el.classList.remove('is-pointer-active');});
  });

  document.querySelectorAll('[data-mw-cr-hero-react]').forEach(function(el){
    el.addEventListener('pointermove',function(e){
      var p=pointerRatio(el,e);
      el.style.setProperty('--cr-hero-x',((p.x-.5)*10).toFixed(1)+'px');
      el.style.setProperty('--cr-hero-y',((p.y-.5)*8).toFixed(1)+'px');
    });
    el.addEventListener('pointerleave',function(){
      el.style.setProperty('--cr-hero-x','0px');
      el.style.setProperty('--cr-hero-y','0px');
    });
  });

  document.querySelectorAll('.mw-cr__card').forEach(function(card){
    card.addEventListener('pointermove',function(e){
      var p=pointerRatio(card,e);
      card.style.setProperty('--cr-img-x',((p.x-.5)*9).toFixed(1)+'px');
      card.style.setProperty('--cr-img-y',((p.y-.5)*7).toFixed(1)+'px');
    });
    card.addEventListener('pointerleave',function(){
      card.style.setProperty('--cr-img-x','0px');
      card.style.setProperty('--cr-img-y','0px');
    });
  });

  document.querySelectorAll('.mw-cr__hero-cta,.mw-cr__hero-link,.mw-cr__community-link,.mw-cr__chapter-cta,.mw-cr__button').forEach(function(el){
    el.addEventListener('pointermove',function(e){
      var p=pointerRatio(el,e);
      el.style.transform='translate3d('+((p.x-.5)*8).toFixed(1)+'px,'+((p.y-.5)*6).toFixed(1)+'px,0)';
    });
    el.addEventListener('pointerleave',function(){el.style.transform='';});
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-feedback"]) return;
  try {
    
  (() => {
    const form = document.getElementById('mw-feedback-form');
    if (!form) return;
    const status = form.querySelector('[data-feedback-status]');
    if (status) status.focus();
    const radios = [...form.querySelectorAll('input[name="contact[feedback_type]"]')];
    const product = form.querySelector('#mw-feedback-product');
    const productField = form.querySelector('[data-feedback-product-field]');
    const source = form.querySelector('#mw-feedback-page');
    const message = form.querySelector('#mw-feedback-message');
    if (!radios.length || !product || !productField || !source || !message) return;
    const params = new URLSearchParams(window.location.search);
    const requestedTopic = params.get('topic');
    if (!status && ['website', 'product'].includes(requestedTopic)) {
      radios.forEach(radio => { radio.checked = radio.value === requestedTopic; });
    }
    if (!product.value && params.get('product')) product.value = params.get('product').slice(0, 180);
    const from = params.get('from');
    if (!source.value && from && from.startsWith('/') && !from.startsWith('//')) {
      try {
        const sourceUrl = new URL(from, window.location.origin);
        if (sourceUrl.origin === window.location.origin) source.value = sourceUrl.origin + sourceUrl.pathname;
      } catch {}
    }
    function updateFields() {
      const isProduct = radios.some(radio => radio.checked && radio.value === 'product');
      productField.hidden = !isProduct;
      product.disabled = !isProduct;
      product.required = isProduct;
      message.placeholder = isProduct ? message.dataset.productPlaceholder : message.dataset.websitePlaceholder;
    }
    radios.forEach(radio => radio.addEventListener('change', updateFields));
    updateFields();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-header"]) return;
  try {
    
(() => {
  const header = document.querySelector('.mw-header');
  const menu = header?.querySelector('.mw-broad-menu');
  if (!menu) return;
  const summary = menu.querySelector('summary');
  const updatePosition = () => {
    header.style.setProperty('--mw-menu-top', `${header.offsetHeight}px`);
    const height = Math.min(innerHeight, window.visualViewport?.height || innerHeight);
    header.style.setProperty('--mw-menu-height', `${Math.max(0, height - header.offsetHeight - 16)}px`);
  };
  window.addEventListener('resize', updatePosition);
  window.visualViewport?.addEventListener('resize', updatePosition);
  new ResizeObserver(updatePosition).observe(header);
  updatePosition();
  menu.addEventListener('toggle', () => { if (menu.open) updatePosition(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      summary.focus();
    }
  });
  document.addEventListener('click', event => {
    if (menu.open && (!menu.contains(event.target) || event.target.closest('.mw-broad-panel a'))) menu.open = false;
  });
  document.addEventListener('cart:change', event => {
    const count = event.detail?.item_count;
    if (typeof count === 'number') header.querySelectorAll('.cart-count').forEach(node => { node.textContent = count; });
  });
  menu.querySelectorAll('a').forEach(link => {
    const destination = new URL(link.href, location.origin);
    if (!destination.hash && destination.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) link.setAttribute('aria-current', 'page');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
